import * as React from 'react';

import { Image } from './styles';
import Utils from '../../../utils';
import { AvatarSize } from '../../../containers/ProfilePage/reducer';

interface UserAvatarProps {
	imageSrc: string;
	x?: number;
	y?: number;
	width?: number;
	height?: number;
	size: AvatarSize;
}

const UserAvatar = ({ imageSrc, x, y, width, height, size }: UserAvatarProps) => (
	<Image
		x={x}
		y={y}
		width={width}
		height={height}
		size={size}
	>
		{imageSrc
			? <img src={imageSrc} alt="" />
			: Utils.getSvgIcon('iconset_uprez-user_avatar')
		}
	</Image>
);

export default UserAvatar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/UserAvatar/index.tsx